import { useState } from 'react';

export const useChannelEdit = (deviceInputs, initialInput, setInputToAdd, setError) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [inputToEdit, setInputToEdit] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = (isEdit = false, channelId = null) => {
    if (isEdit && channelId) {
      const channelToEdit = deviceInputs.find((input) => input.input_number === channelId);
      if (channelToEdit) {
        setInputToEdit(channelToEdit);
        setInputToAdd(channelToEdit);
        setIsEditMode(true);
      }
    } else {
      setIsEditMode(false);
      setInputToEdit(null);
      setInputToAdd(initialInput);
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setIsEditMode(false);
    setInputToEdit(null);
    setInputToAdd(initialInput);
    setError([]);
  };

  return {
    isEditMode,
    inputToEdit,
    showModal,
    setShowModal,
    handleOpenModal,
    handleCloseModal,
  };
};
